var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23411 1.20314L7.23428 1.20298C7.42097 1.01652 7.67404 0.911787 7.9379 0.911787C8.20175 0.911787 8.45482 1.01652 8.64152 1.20298L8.64168 1.20314L14.8486 7.41004L14.8579 7.4194L14.8578 7.41956C15.0336 7.60831 15.1294 7.85796 15.1248 8.11591C15.1203 8.37386 15.0158 8.61998 14.8334 8.8024C14.6509 8.98483 14.4048 9.08933 14.1469 9.09388C13.8889 9.09843 13.6393 9.00268 13.4505 8.8268L13.4408 8.81778L13.441 8.81761L7.9379 3.3145L2.43891 8.81349C2.34876 8.90881 2.24064 8.98539 2.12076 9.0388C1.99862 9.09322 1.86677 9.12249 1.73308 9.12484C1.59939 9.1272 1.46659 9.10261 1.34261 9.05253L1.48267 8.7058L1.34261 9.05253C1.21863 9.00245 1.10601 8.92792 1.01146 8.83337C1.01146 8.83337 1.01146 8.83337 1.01146 8.83337L1.27614 8.56869L7.23411 1.20314ZM7.23411 1.20314L1.03133 7.40592L7.23411 1.20314Z",
    fill: "#474F63",
    stroke: "#474F63",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.5de5a7d6486bf6836dcdebdb3b5fc1d3.svg";
export { ForwardRef as ReactComponent };